exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".paused[data-v-834c816e] {\n  opacity: 0.5;\n}\n", ""]);

